import React, { Component, Suspense, lazy } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { Auth } from "aws-amplify";
import Swal from "sweetalert2";
import { history } from "../store";
import DataHqCompany from "../Controls/Select/DataHqCompany";

const Home = React.lazy(() => import("../containers/Home/index.home"));
const GrHome = React.lazy(() => import("../containers/GrSurveyor/index.home"));
const UpdateSurveyorEmail = React.lazy(() => import("../containers/UpdateSurveyorEmail/index.shipment"));
const Shipment = React.lazy(() =>
  import("../containers/Shipment/index.shipment")
);
const ShipmentGr = React.lazy(() =>
  import("../containers/ShipmentGr/index.shipment")
);
const Account = React.lazy(() => import("../containers/Account/index.account"));
const ShipmentDetail = React.lazy(() =>
  import("../containers/ShipmentDetail/index.shipmentDetail")
);
const ShipmentDetailGr = React.lazy(() =>
  import("../containers/ShipmentDetailGr/index.shipmentDetail")
);
const Timelog = React.lazy(() => import("../containers/Timelog/index.timelog"));
const Arrival = React.lazy(() => import("../containers/Arrival/index.arrival"));
const Departure = React.lazy(() =>
  import("../containers/Departure/index.departure")
);
const Discharge = React.lazy(() =>
  import("../containers/Discharge/index.discharge")
);
const DischargeVopsPipe = React.lazy(() =>
  import("../containers/DischargeVopsPipe/index.discharge")
);
const DischargeVopsSurveyor = React.lazy(() =>
  import("../containers/DischargeVopsSurveyor/index.discharge")
);
const UserList = React.lazy(() =>
  import("../containers/UserList/index.userlist")
);

export default ( {user} ) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Switch>
        <PrivateRoute path="/home" component={user.group === "petco_surveyor_autogr" ? GrHome : Home} exact />
        <PrivateRoute path="/myaccount" component={Account} exact />
        <PrivateRoute path="/grhome" component={GrHome} exact />
        <PrivateRoute path="/updateSurveyorEmail"component={UpdateSurveyorEmail} exact />
        <PrivateRoute
          path="/shipment/:port_type/:shipment_id/:vessel_name/:OPU"
          component={Shipment}
          exact
        />
        <PrivateRoute
          path="/shipmentGr/:SAPDeliveryNo/:TransportVessel"
          component={ShipmentGr}
          exact
        />
        <PrivateRoute
          path="/shipment-detail/:shipment_id/:vessel_name/:OPU"
          component={ShipmentDetail}
          exact
        />
        <PrivateRoute
          path="/shipment-detail-gr/:sapdeliveryno"
          component={ShipmentDetailGr}
          exact
        />
        <PrivateRoute
          path="/arrival/:report/:shipment_id/:vessel/:port/:from_port_type/:file/:action"
          component={Arrival}
          exact
        />
        <PrivateRoute
          path="/timelog/:report/:shipment_id/:vessel/:port/:from_port_type/:file/:discharge_product1/:discharge_product2/:discharge_product3/:discharge_product4/:discharge_product5/:discharge_product6/:discharge_product7/:discharge_product8/:job_number/:surveyor_company/:agent_company/:vops_id/:action/:OPU"
          component={Timelog}
          exact
        />
        <PrivateRoute
          path="/departure/:report/:shipment_id/:vessel/:port/:from_port_type/:file/:next_port/:discharge_port1/:discharge_port2/:discharge_port3/:action"
          component={Departure}
          exact
        />
        <PrivateRoute
          path="/discharge/:report/:shipment_id/:vessel/:port/:from_port_type/:file/:product/:product_num/:action"
          component={Discharge}
          exact
        />
        <PrivateRoute
          path="/dischargeVopsPipe/:SAPDeliveryNo/:action"
          component={DischargeVopsPipe}
          exact
        />
        <PrivateRoute
          path="/dischargeVopsSurveyor/:SAPDeliveryNo/:action"
          component={DischargeVopsSurveyor}
          exact
        />
        
        <Redirect from="/" to="/home" />
      </Switch>
    </Suspense>
  );
};
class PrivateRoute extends Component {
  async componentDidMount() {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const list_group =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      let is_user_hq = false;
      if (list_group) {
        list_group.map((group_value, index) => {
          if (group_value == "hq") {
            is_user_hq = true;
          }
        });
      }

      if (is_user_hq != true) {
        if (user) {
          if (user.attributes["custom:is_approve"] == "0") {
            DataHqCompany.map((values, index) => {
              let company_email = user.attributes["custom:company_email"];
              let companyEmail = company_email.split(",");
              companyEmail.forEach((email) => {
                if (email.includes(values.value)) {
                  throw {
                    message:
                      "Pending user validation from HQ, please contact your HQ for Verification",
                  };
                }
              });
            });
          }
        }
      }

      if (this.props.location.pathname) {
        history.push(this.props.location.pathname);
      } else {
        history.push("/home");
      }
    } catch (e) {
      const status = await Auth.signOut();
      if (e == "not authenticated") {
        history.push("/login");
      } else {
        Swal.fire("Error", e.message, "error");
      }
    }
  }
  render() {
    const { component, path } = this.props;
    return <Route path={path} component={component} exact={true} />;
  }
}



// WEBPACK FOOTER //
// ./src/routes/routes.js